import { toast } from "@/lib/toast";
import { FileText, FolderOpen } from "lucide-react";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const COMM_TYPES = [
  { id: "document", label: "Envoi de document", icon: FileText },
  { id: "demande_document", label: "Demande de document", icon: FolderOpen },
];

export const TYPE_LABELS = Object.fromEntries(COMM_TYPES.map(t => [t.id, t.label]));

// Legacy types still rendered cleanly if found in old data
const LEGACY_LABELS = {
  demande_manquant: "Document manquant",
  transmission: "Transmission",
  message: "Message",
};
Object.entries(LEGACY_LABELS).forEach(([k, v]) => { if (!TYPE_LABELS[k]) TYPE_LABELS[k] = v; });

export const TYPE_COLORS = {
  document: "bg-blue-100 text-blue-700",
  demande_document: "bg-amber-100 text-amber-700",
  // Legacy (kept for old records visibility)
  demande_manquant: "bg-gray-100 text-gray-500",
  transmission: "bg-gray-100 text-gray-500",
  message: "bg-gray-100 text-gray-500",
};

export const STATUS_COLORS = {
  envoye: "bg-blue-100 text-blue-700",
  recu: "bg-green-100 text-green-700",
  lu: "bg-gray-100 text-gray-600",
  complete: "bg-emerald-100 text-emerald-700",
  en_attente: "bg-amber-100 text-amber-700",
};

export function secureDownloadFile(fileUrl, filename) {
  const token = localStorage.getItem("token");
  if (!token) return;
  const url = fileUrl.startsWith("http") ? fileUrl : `${API_BASE}${fileUrl}`;
  fetch(url, { headers: { Authorization: `Bearer ${token}` } })
    .then(r => r.blob())
    .then(blob => {
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = filename || "document";
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    })
    .catch(() => toast.error("Erreur de telechargement"));
}

export const ACCEPTED_EXTS = ".pdf,.png,.jpg,.jpeg,.webp,.gif,.doc,.docx,.xls,.xlsx,.csv,.txt,.heic";
export const MAX_ATTACHMENT_MB = 25;
